import { Col, Row } from 'antd';
import { stringDate } from '../../../../../util';
import { formatPrice } from '../../../../../util/formatPrice';

export const ConsignOrderGeneralData = ({ data = {} }) => {
  return (
    <>
      <Row className="row">
        <Col span={8}>
          <h4>Proveedor</h4>
        </Col>
        <Col span={16}>{data?.provider?.name || '-'}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>Número de orden</h4>
        </Col>
        <Col span={16}>{data?.orderNumber ? `CN${data.orderNumber}` : '-'}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>Fecha llegada</h4>
        </Col>
        <Col span={16}>{stringDate(data?.arrivedAt) || '-'}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>Estado</h4>
        </Col>
        <Col span={16}>{data?.status || '-'}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>IVA</h4>
        </Col>
        <Col span={16}>{data?.tax ? `${data.tax}%` : '0%'}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>Total</h4>
        </Col>
        <Col span={16}>{formatPrice(data.amount)}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>Comentarios</h4>
        </Col>
        <Col span={16}>{data?.comments || '—'}</Col>
      </Row>
    </>
  );
};
